const buttonDefaultStateTheme = {
  buttonThemeClasses: '',
  buttonThemeVariantClasses: '',
  buttonThemeSizeClasses: '',
  buttonThemeTextClasses: '',
  buttonThemeIconClasses: '',
  buttonThemeOnlyIconSizeClasses: '',
};

export default buttonDefaultStateTheme;
